import React, { createContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import SMLModal from '../../../../shared/components/SMLModal';
import EnterSkus from './EnterSkus';
import Confirm from './Confirm';
import Submit from './Submit';

export const ReportSkusModalContext = createContext();

const ReportSkusModal = (props) => {
  const [step, setStep] = useState(1);
  const [titles, setTitles] = useState([]);
  const [songs, setSongs] = useState([]);
  const [count, setCount] = useState(0);
  const [missing, setMissing] = useState(true);
  const [modalSize, setModalSize] = useState('sm');
  const [skus, setSkus] = useState('');
  const [dataToFill, setDataToFill] = useState({});

  const hideModal = () => {
    $('#reportSkusModal').modal('hide');
  }

  const handleModalShown = () => {
    setTitles([]);
    setSongs([]);
    setCount(0);
    setStep(1);
    setSkus('');
  };

  useEffect(() => {
    if (step === 3) {
      setModalSize('lg');
    } else {
      setModalSize('md');
    }
  }, [step]);

  useEffect(() => {
    if (!props.master) {
      setDataToFill({
        masterUses: null,
        masterSource: null
      });
    }
  }, []);

  return (
    <ReportSkusModalContext.Provider value={{ hideModal, setStep, setSongs, setCount, setMissing, setTitles, setSkus }}>
      <SMLModal onShown={handleModalShown} id={'reportSkusModal'} size={modalSize}>
        <h3 className="text-center">Report multiple songs</h3>

        {step === 1 &&
          <EnterSkus skus={skus} />
        }

        {step === 2 &&
          <Confirm songs={songs} count={count} missing={missing} />
        }

        {step === 3 &&
          <Submit 
            postedVideosChoices={props.postedVideosChoices}
            lyricUsesChoices={props.lyricUsesChoices}
            masterUsesChoices={props.masterUsesChoices}
            masterSourceChoices={props.masterSourceChoices}
            master={props.master}
            titles={titles}
            dataToFill={dataToFill}
          />
        }
      </SMLModal>
    </ReportSkusModalContext.Provider>
  );
};

export default ReportSkusModal;

// Bind react component to all occurences of html tag with id ReportSkusModal
$('#ReportSkusModal').each(function () {
  createRoot(this).render(
    React.createElement(ReportSkusModal, { ...($(this).data()) })
  );
});